import React, { useState, useRef, useEffect } from "react";

function PlantSelect({ plantOptions, value, onChange, placeholder }) {
    const [query, setQuery] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const filtered = plantOptions.filter(opt =>
        opt.label.toLowerCase().includes(query.toLowerCase())
    );

    const handleSelect = (opt) => {
        onChange(opt.key);

        // 🔥 Clear query so user can quickly add another
        setQuery("");
        setShowDropdown(false);
    };

    return (
        <div ref={wrapperRef} style={{ position: "relative" }}>
            <input
                type="text"
                className="form-control"
                value={query}
                placeholder={placeholder || "Search plants..."}
                style={{
                    border: "1px solid #D6DDD6",
                    boxShadow: "none",
                    fontSize: "13px",
                    padding: "6px 8px",
                }}
                onChange={(e) => {
                    setQuery(e.target.value);
                    setShowDropdown(true);
                }}
                onFocus={() => setShowDropdown(true)}
            />

            {showDropdown && query.length > 0 && (
                <ul
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        zIndex: 1000,
                        background: "#fff",
                        border: "1px solid #D6DDD6",
                        borderTop: "none",
                        margin: 0,
                        padding: 0,
                        listStyle: "none",
                        maxHeight: "180px",
                        overflowY: "auto",
                        fontSize: "13px",
                    }}
                >
                    {filtered.length === 0 && (
                        <li style={{ padding: "8px", color: "#888" }}>
                            No matches
                        </li>
                    )}

                    {filtered.map((opt) => (
                        <li
                            key={opt.key}
                            style={{
                                padding: "6px 8px",
                                cursor: "pointer",
                            }}
                            onClick={() => handleSelect(opt)}
                            onMouseDown={(e) => e.preventDefault()}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.background = "#EEF2EE")
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.background = "transparent")
                            }
                        >
                            {opt.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default PlantSelect;
